'use strict';

angular.module('lingApp')
  .directive('ripDynamicDirective', function ($compile, $animate, RipStrings, RipDynamicDirective, RipState) {
    return {
      template: '<div></div>',
      replace: true,
      restrict: 'E',
      link: function postLink(scope, element, attrs) {
        var currentScope, currentElement;

        scope.$watch(attrs.directive, function(directive, oldDirective) {
          if (directive) {
            var directiveScope = scope.$new();

            var bindings = angular.isFunction(directive.bindings) ? directive.bindings() : directive.bindings;

            if (bindings) {
              angular.extend(directiveScope, bindings);
            }

            if (attrs.ripStateId) {
              RipState.setState(directiveScope, attrs.ripStateId);
            }

            var newElement = angular.element(RipDynamicDirective.compose(directive.directive,
                                                                         bindings,
                                                                         directive.attributes));

            cleanupLastView();
            $animate.enter(newElement, element);
            $compile(newElement)(directiveScope);

            currentElement = newElement;
            currentScope = directiveScope;

          } else {
            cleanupLastView();
          }
        });

        function cleanupLastView() {
          if (currentScope) {
            currentScope.$destroy();
            currentScope = null;
          }

          if (currentElement) {
            $animate.leave(currentElement);
            currentElement = null;
          }
        }
      }
    };
  })

  .factory('RipDynamicDirective', function(RipStrings) {
    return {
      compose: function(directive, bindings, attributes) {
        return RipStrings.format('<{0} {1} {2}></{0}>',
                                 RipStrings.camelCaseToSnakeCase(directive),
                                 (_.chain(bindings)
                                  .keys()
                                  .map(function(key) { return RipStrings.camelCaseToSnakeCase(key) + '="' + key + '"'; })
                                  .join(' ')
                                  .value()),
                                 attributes
                                 ? (_.chain(attributes)
                                    .keys()
                                    .map(function(key) { return RipStrings.camelCaseToSnakeCase(key) + '="' + attributes[key] + '"'; })
                                    .join(' '))
                                 : ''
                                );
      },
    };
  })
;
